import { defineStore, acceptHMRUpdate } from 'pinia'

interface GroupCardState {
  // Pinia state for the group card selection panel.

  selectedGroupId: string | null
  // Id of the currently selected group; null when none is selected.
}

export const useGroupCardStore = defineStore('groupCard', {
  state: (): GroupCardState => ({
    selectedGroupId: null,
  }),
  getters: {
    hasSelection: (state): boolean => state.selectedGroupId !== null,
  },
  actions: {
    selectGroup(id: string): void {
      if (this.selectedGroupId === id) return
      this.selectedGroupId = id
    },
    clearSelection(): void {
      this.selectedGroupId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGroupCardStore, import.meta.hot))
}
